import { create } from "zustand";

interface IProfileDetailsStore {
  isLoading: boolean;
  isPageLoading: boolean;
  isCashfreeLoading:boolean;
  loadingMsg: string;
  setIsLoading: (data: boolean) => void;
  setLoadingMsg: (data: string) => void;
  setIsPageLoading: (data: boolean) => void;
  setIsCashfreeLoading: (data: boolean) => void;
}

export const useLoadingStore = create<IProfileDetailsStore>((set) => ({
  isLoading: false,
  loadingMsg: "",
  isPageLoading:false,
  isCashfreeLoading:false,
  setIsLoading: (data) => set((state) => ({ ...state, isLoading: data })),
  setLoadingMsg: (data) => set((state) => ({ ...state, loadingMsg: data })),
  setIsPageLoading: (data) => set((state) => ({ ...state, isPageLoading: data })),
  setIsCashfreeLoading: (data) => set((state) => ({ ...state, isCashfreeLoading: data })),

}));
